import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  Container,
  Badge,
} from 'reactstrap';
import moment from 'moment';

import { ApiContext } from 'src/utils/ApiContext';

// v9: the hoc
import { withNamespaces } from 'react-i18next';
import LanguageBar from './LanguageBar';

/** @typedef {import('@src/utils/types').User} User */

export default withNamespaces()(StatusBarAuthed);
function StatusBarAuthed(props) {
  const {
    showModalBindSelect,
    showModalTrancSelect,
    showModalWithdrawSelect,
    time,
    onUnbindUser,
    showModalOrders,
  } = props;

  const { t } = props;

  const apiCtx = React.useContext(ApiContext);

  const [isOpen, setIsOpen] = React.useState(false);

  /** @type {User} */
  const user = apiCtx.user;
  const { uid } = user;
  const { coin } = user;
  // const { coin_usdt } = user;
  const { wid } = user;
  const isBinded = wid !== '';

  return (
    <div style={{ backgroundColor: '#162831' }}>
      <Container>
        <Navbar expand={'md'} dark>
          <NavbarBrand>
            <div style={{ color: 'white', fontSize: 10 }}>
              <p>{moment(time).format('YYYY-MM-DD hh:mm:ss')}</p>
              <p>{apiCtx.version}</p>
            </div>
            <LanguageBar />
          </NavbarBrand>

          <NavbarToggler onClick={() => setIsOpen(!isOpen)} />

          <Collapse isOpen={isOpen} navbar>
            <Nav className={'ml-auto'} navbar>
              <NavItem className={'mx-2'}>
                <NavLink href="#" style={{ color: 'white' }} disabled>
                  {uid}
                </NavLink>
                <Badge color={isBinded ? 'success' : 'danger'}>
                  {isBinded
                    ? t('statusBarAuthed.bindState')
                    : t('statusBarAuthed.unbindState')}
                </Badge>
              </NavItem>

              {isBinded && (
                <NavItem className={'mx-2'}>
                  <NavLink href="#" style={{ color: 'white' }} disabled>
                    {wid}
                  </NavLink>
                  <Badge color="warning">{t('Home.PayName')}</Badge>
                </NavItem>
              )}

              {
                <>
                  <NavItem className={'mx-2'}>
                    <NavLink href="#" style={{ color: 'white' }} disabled>
                      {coin}
                    </NavLink>
                    <Badge color="primary">{t('statusBarAuthed.Coin')}</Badge>
                  </NavItem>

                  {/* <NavItem className={'mx-2'}>
                    <NavLink href="#" style={{ color: 'white' }} disabled>
                      {coin_usdt}
                    </NavLink>
                    <Badge color="secondary">USDT</Badge>
                  </NavItem> */}

                  <NavItem className={'mx-2'}>
                    <button
                      className={'btn btn-success mr-2 my-2 my-lg-0'}
                      onClick={showModalTrancSelect}
                    >
                      {t('statusBarAuthed.deposit')}
                    </button>
                  </NavItem>
                  <NavItem className={'mx-2'}>
                    <button
                      className={'btn btn-info mr-4 my-2 my-lg-0'}
                      onClick={showModalWithdrawSelect}
                    >
                      {t('statusBarAuthed.withdraw')}
                    </button>
                  </NavItem>
                </>
              }

              {isBinded && (
                <NavItem className={'mx-2'}>
                  <button
                    className={'btn btn-danger mr-2 my-2 my-lg-0'}
                    onClick={onUnbindUser}
                  >
                    {t('statusBarAuthed.unbind')}
                  </button>
                </NavItem>
              )}

              {!isBinded && (
                <NavItem className={'mx-2'}>
                  <button
                    className={'btn btn-danger mr-2 my-2 my-lg-0'}
                    onClick={showModalBindSelect}
                  >
                    {t('statusBarAuthed.bind')}
                  </button>
                </NavItem>
              )}

              <NavItem className={'mx-2'}>
                <button
                  className={'btn btn-warning mr-2 my-2 my-lg-0'}
                  onClick={showModalOrders}
                >
                  {t('statusBarAuthed.orders')}
                </button>
              </NavItem>

              <NavItem className={'mx-2'}>
                <button
                  className={'btn btn-outline-warning mr-2 my-2 my-lg-0'}
                  onClick={() => apiCtx.logout()}
                >
                  {t('statusBarAuthed.logout')}
                </button>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </Container>
    </div>
  );
}
